/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconWifi: {
  name: 'wifi';
  data: string;
} = {
  name: 'wifi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M346.552 404.583c-22.12-22.12-57.984-22.12-80.104 0s-22.12 57.984 0 80.104c22.12 22.12 57.984 22.12 80.104 0 22.12-22.121 22.12-57.984 0-80.104"/><path d="m500.085 331.155-56.74 56.74c-75.577-75.577-198.112-75.577-273.689 0l-56.74-56.74c106.914-106.915 280.255-106.915 387.169 0z"/><path d="M540.137 291.102c-129.034-129.034-338.24-129.034-467.274 0l-58.409-58.409c161.292-161.292 422.8-161.292 584.092 0l-58.409 58.409z"/></svg>`,
};
